/** @jsxImportSource @emotion/react */

import { PenTool as PenToolIcon } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import lineDrawer from 'ud-ui/components/fabric-canvas/addons/line-drawer';
import UDTippy from 'ud-ui/components/tippy';
import { selectActiveModal, selectFabricManager } from '../../../../store/editor/selectors';
import { IconButton, IconWrapper } from './styles';

export function PenTool() {
  const activeModal = useSelector(selectActiveModal);
  const fabricManager = useSelector(selectFabricManager);
  const [isSelected, setSelected] = useState<boolean>(false);

  useEffect(() => {
    const unsubscribe = lineDrawer.drawMode.subscribe((value) => {
      setSelected(value);
    });
    return () => unsubscribe();
  }, []);

  const onClickPen = () => {
    if (!fabricManager) return;
    if (isSelected) {
      setSelected(false);
      lineDrawer.edit();
      return;
    }

    setSelected(true);
    lineDrawer.draw();
  };

  return (
    <UDTippy disabled={Boolean(activeModal)} content={'Перо'} size="xs">
      <span style={{ display: 'inline-block' }}>
        <IconButton style={{ color: isSelected ? '#D9B244' : undefined }} onClick={onClickPen} tabIndex={0}>
          <IconWrapper icon={<PenToolIcon size={20} strokeWidth={1.5} />} />
        </IconButton>
      </span>
    </UDTippy>
  );
}
